import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import EditorialModuleArticles from 'dibs-editorial-module/exports/EditorialModuleArticles';
import { SbSharedWordpressArticlesContainer } from './SbSharedWordpressArticlesContainer';

import { SbSharedWordpressArticlesWrapper_editorial } from './__generated__/SbSharedWordpressArticlesWrapper_editorial.graphql';
import { SbSharedWordpressArticlesWrapper_viewer } from './__generated__/SbSharedWordpressArticlesWrapper_viewer.graphql';

const NUM_ARTICLES_TO_SHOW = 2;

type Props = {
    editorial: SbSharedWordpressArticlesWrapper_editorial | null;
    viewer: SbSharedWordpressArticlesWrapper_viewer;
};

const SbSharedWordpressArticlesWrapperComponent: FC<Props> = ({ editorial, viewer }) => {
    const showEditorial = (editorial?.totalResults || 0) > 0;
    if (viewer?.isWordpressArticlesEnabled && showEditorial) {
        return (
            <SbSharedWordpressArticlesContainer>
                <EditorialModuleArticles
                    articles={(editorial?.articles || []).slice(0, NUM_ARTICLES_TO_SHOW)}
                />
            </SbSharedWordpressArticlesContainer>
        );
    }
    return null;
};

export const SbSharedWordpressArticlesWrapper = createFragmentContainer(
    SbSharedWordpressArticlesWrapperComponent,
    {
        viewer: graphql`
            fragment SbSharedWordpressArticlesWrapper_viewer on Viewer {
                isWordpressArticlesEnabled: featureFlag(feature: "wordpressArticles")
            }
        `,
        editorial: graphql`
            fragment SbSharedWordpressArticlesWrapper_editorial on WordpressArticlesType {
                articles {
                    ...EditorialModuleArticles_articles
                }
                totalResults
            }
        `,
    }
);
